import { render, staticRenderFns } from "./UserDisplay.vue?vue&type=template&id=561f62be&"
import script from "./UserDisplay.vue?vue&type=script&lang=ts&"
export * from "./UserDisplay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports